import { Box, Flex, Text } from '@modusign/design-system';
import { useFormContext } from 'react-hook-form';

import LocaleCode from '@app/store/LocaleCode';

interface SignerLanguageSelectProps {
  signerId: string;
}

export default function SignerLanguageSelect({ signerId }: SignerLanguageSelectProps) {
  const { register } = useFormContext();

  return (
    <Flex alignItems="center" height="21px">
      <svg
        fill="none"
        height="14"
        style={{ stroke: '#474747' }}
        viewBox="0 0 16 16"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="7.4" strokeWidth="1.2" />
        <path
          d="M10.4 8C10.4 10.1562 10.0712 12.0816 9.55952 13.4462C9.30284 14.1307 9.01167 14.6429 8.71878 14.9733C8.42527 15.3043 8.18101 15.4 8 15.4C7.81899 15.4 7.57473 15.3043 7.28122 14.9733C6.98833 14.6429 6.69716 14.1307 6.44048 13.4462C5.92877 12.0816 5.6 10.1562 5.6 8C5.6 5.84376 5.92877 3.91838 6.44048 2.55382C6.69716 1.86932 6.98833 1.35707 7.28122 1.02672C7.57473 0.695677 7.81899 0.6 8 0.6C8.18101 0.6 8.42527 0.695677 8.71878 1.02672C9.01167 1.35707 9.30284 1.86932 9.55952 2.55382C10.0712 3.91838 10.4 5.84376 10.4 8Z"
          strokeWidth="1.2"
        />
        <path
          d="M1 8C1 8 3.66734 8 7.53333 8C11.3993 8 15 8 15 8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </svg>
      <Box
        as="select"
        border="none"
        color="textNeutralSlightlyLight"
        fontSize="12px"
        fontWeight="medium"
        mx={1}
        name={`${signerId}.locale`}
        ref={register()}
        sx={{
          appearance: 'none',
          background: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 0.5L5 4.5L9 0.5' stroke='%23757575'/%3E%3C/svg%3E%0A") no-repeat center right`,
          width: '45px',
        }}
      >
        <option value={LocaleCode.KOREAN}>한국어</option>
        <option value={LocaleCode.ENGLISH}>영어</option>
        <option value={LocaleCode.CHINESE}>중국어</option>
        <option value={LocaleCode.JAPANESE}>일본어</option>
        <option value={LocaleCode.VIETNAMESE}>베트남어</option>
      </Box>
      <Text color="textNeutralLight" fontSize="xs">
        로 알림을 보냅니다.
      </Text>
    </Flex>
  );
}
